import { formatAmount } from "@/lib/utils";
import { setCommunityData, setCurrentFinanceYear } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { useGetBomDashboardStat, useGetCommunities } from "@/services";
import { Hotel, User, NotebookText } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useBomLeftSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [firstSectionCard, setFirstSectionCard] = useState([
    {
      id: "1",
      icon: Hotel,
      count: 200,
      title: "Properties",
      className: "bg-amber-100",
      dataBorderColor: "border-amber-300",
      dataClassName: "bg-amber-50",
    },
    {
      id: "2",
      icon: User,
      count: 150,
      title: "Active Users",
      className: "bg-blue-100",
      dataBorderColor: "border-blue-300",
      dataClassName: "bg-blue-50",
      data: [
        { count: 0, label: "Owners", apiKey: "ownerCount" },
        { count: 0, label: "Tenants", apiKey: "tenantCount" },
      ],
    },
    {
      id: "3",
      icon: NotebookText,
      count: 150,
      title: "Total Vendors",
      className: "bg-purple-100",
      dataBorderColor: "border-purple-300",
      dataClassName: "bg-purple-50",
      data: [
        { count: 0, label: "Active", apiKey: "totalActiveVendors" },
        { count: 0, label: "Inactive", apiKey: "totalInActiveVendors" },
      ],
    },
  ]);

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );
  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );

  const { data: communityList, isLoading: isCommunityLoading } =
    useGetCommunities({});

  useEffect(() => {
    if (!communityDetail?.communityId) {
      dispatch(setCommunityData(communityList?.data?.[0]));
    }
  }, [communityList]);

  const { data: stat } = useGetBomDashboardStat({
    communityId: communityDetail?.communityId,
    queryParams: {
      enabled: !!communityDetail?.communityId,
    },
  });

  useEffect(() => {
    if (stat) {
      const firstSectionData = [...firstSectionCard];

      const _firstSectionData = firstSectionData?.map((data: any) => {
        let total = 0;
        let _data = null;

        if (data?.id == "1") {
          _data = stat?.data?.modelStats?.map((val: any) => {
            total = total + val?.propertyCount || 0;
            return {
              ...val,
              label: val?.modelName?.toUpperCase(),
              count: val?.propertyCount,
            };
          });
        } else if (data?.apiKey) {
          total = stat?.data?.[data?.apiKey] || 0;
          _data = data?.data?.map((val: any) => {
            return {
              ...val,
              count: formatAmount(stat?.data?.[val?.apiKey] || "0"),
            };
          });
        } else {
          _data = data?.data?.map((val: any) => {
            total = total + stat?.data?.[val?.apiKey] || 0;
            return { ...val, count: stat?.data?.[val?.apiKey] || "0" };
          });
        }
        return {
          ...data,
          data: _data,
          count: total,
        };
      });

      setFirstSectionCard([..._firstSectionData]);
    }
  }, [stat]);

  const onYearChange = (year: string) => {
    dispatch(setCurrentFinanceYear(year));
  };

  const onCommunityChange = (id: any) => {
    dispatch(
      setCommunityData(
        communityList?.data?.find((val: any) => val.communityId == id)
      )
    );
  };

  return {
    communityDetail,
    loggedInUserData,
    firstSectionCard,
    navigate,
    currentFinanceYear,
    onYearChange,
    communityList,
    isCommunityLoading,
    onCommunityChange,
  };
};

export default useBomLeftSection;
